// extracted by mini-css-extract-plugin
export var banner = "banner-module--banner--sD0Xc";